module.exports = __webpack_public_path__ + "static/media/edit.83cef007.svg";